export default {"src":"/_next/static/media/chain.2dc3a984.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};